window.Vue = require('vue');
require('vue-events');
import store from "./stores/launch2023_store";

import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css'

import "./styles/imports.scss";

import App from "./App.vue";

Vue.use(VuePlyr, {
    plyr: {}
  })

Vue.component("app", require("./App.vue"));
Vue.component("vw-button", require("./components/vw-button.vue"));
Vue.component("AppIconBase", require("./components/AppIconBase.vue"));
Vue.component("AppSingleColumn", require("./components/AppSingleColumn.vue"));
Vue.component("AppResponsiveImage", require("./components/AppResponsiveImage.vue"));
Vue.component("ProductIndicator", require("./components/ProductIndicator.vue"));
Vue.component("AppTwoCols", require("./components/AppTwoCols.vue"));

const app = new Vue({
    el: "#Launch2023",
    store,
    //render: (h) => h(App)
});



// WEBPACK FOOTER //
// ./resources/assets/vuejs/frontend/2023-launch/main.js